module.exports = __webpack_public_path__ + "static/media/27.7f83ec53.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/27.png
// module id = 809
// module chunks = 0